import {generateFetchOptions} from '../index';

// PATCH /api/v1/applicants/:applicant_id/onboarding/complete
export async function complete(applicantId: string, applicantOnboardingData: any): Promise<Response> {
  return fetch(
    `${process.env.REACT_APP_API_HOST}/api/v1/applicants/${applicantId}/onboarding/complete`,
    generateFetchOptions({
      method: 'PATCH',
      isProtected: true,
      body: applicantOnboardingData,
    })
  );
}
